import React, { useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import '../App.css';
import { SERVER_URL } from '../AppRouter'

function Landing() {
  const queryString = new URLSearchParams(window.location.search);

  const navigate = useNavigate();
  useEffect(() => {
    const token = queryString.get("token") || null
    if (!token){
      navigate("/notFound");
    }
    axios({
      method: 'get',
      url: `${SERVER_URL}?path=landing&token=${token}`,
      withCredentials: false,
    }).then((response) => {
      if (response.status < 400){
        if (response.data['newRoute'] === 'feedback'){
          navigate(`/feedback?token=${token}`);
        } if (response.data['newRoute'] === 'demo'){
            navigate(`/demo?token=${token}`);
        }
      }
    }).catch((error) => {
      navigate("/notFound");
    })
  }, [])

  return (
      <div className="protected full-height">
      </div>
  );
}

export default Landing;
